// extracted by mini-css-extract-plugin
export var container = "_nb-0";
export var dotAnimation = "_nb-2";
export var dotsLoading = "_nb-1";